import React, { useState } from 'react';
import { isMobileScreen, ConfirmV2 } from '@apply/ui';
import { useNavigate } from 'react-router-dom';
import { IconFlyoutMenuButton, FlyoutDirection, IconButtonSize, IconButtonTheme } from '@apply/components';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { faShare, faCog, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { faSignOut, faBars } from '@fortawesome/free-solid-svg-icons';
import { ProfileMenuOption, ProfileMenuSize } from './components/ProfileMenuOption';
import { LoginApi } from '@apply/api';
import { applicationInsights } from '../../../../ApplicationInsights';
import { appActions } from '@apply/adminStore';
const mobileScreen = isMobileScreen();
import { useWaitOverlayStore } from '@apply/components';
import store from '@apply/adminStore';

export const ProfileButton: React.FC<{ printMode?: boolean }> = ({ printMode = false }) => {
    const navigate = useNavigate();
    const loginApi = new LoginApi.LoginApi(applicationInsights);
    const [isConfirmOpen, set_isConfirmOpen] = useState(false);
    const { setWaiting } = useWaitOverlayStore();
    const { user } = store.getState();

    const logUserOut = async () => {
        appActions.setAppLoading(true, 'Logging out...');
        const _logout = await loginApi.logout();

        if (_logout) {
            appActions.setAppLoading(false);
            setTimeout(() => {
                navigate('/login');
            }, 1000);
        } else {
            appActions.setAppLoading(false);
            setTimeout(() => {
                navigate('/login');
            }, 1000);
        }
    };

    const onConfirmLogout = async () => {
        setWaiting(true, 'Logging you out...');
        try {
            await logUserOut();
        } finally {
            set_isConfirmOpen(false);
            navigate('/login');
        }
    };

    const onCancelLogout = () => {
        set_isConfirmOpen(false);
    };

    const handleLogout = () => {
        set_isConfirmOpen(true);
    };

    const handleReferrals = () => {
        navigate('/referrals');
    };

    const handleSettings = () => {
        navigate('/settings');
    };

    const handleReviewAccountInformation = () => {
        navigate('/brokeraccount');
    };

    const handleSignAgreement = () => {
        navigate('/broker/signagreement');
    };

    const nonAcceptedTermsMenuItems = () => {
        return (
            <>
                <ProfileMenuOption
                    onClick={handleReviewAccountInformation}
                    icon={faShare}
                    menuSize={ProfileMenuSize.Condensed}
                >
                    Review Account
                </ProfileMenuOption>
            </>
        );
    };

    const acceptedTermsMenuItems = () => {
        return (
            <>
                <ProfileMenuOption
                    onClick={handleReferrals}
                    icon={faShare}
                    menuSize={ProfileMenuSize.Condensed}
                >
                    Referrals
                </ProfileMenuOption>
                <ProfileMenuOption
                    onClick={handleSettings}
                    icon={faCog}
                    menuSize={ProfileMenuSize.Condensed}
                >
                    Settings
                </ProfileMenuOption>
            </>
        );
    };

    const requiresESignMenuItems = () => {
        return (
            <>
                <ProfileMenuOption
                    onClick={handleSignAgreement}
                    icon={faPenToSquare}
                    menuSize={ProfileMenuSize.Condensed}
                >
                    User Agreement
                </ProfileMenuOption>
            </>
        );
    };

    const menuItems = () => {
        if (user.requiresESign) {
            return requiresESignMenuItems();
        }
        if (user.isBroker) {
            return user.areTermsAccepted ? acceptedTermsMenuItems() : nonAcceptedTermsMenuItems();
        }
        return null;
    };

    const renderProfileButton = (printMode?: boolean) => {
        if (!printMode) {
            if (!mobileScreen) {
                return (
                    <IconFlyoutMenuButton
                        id='profileButton'
                        direction={FlyoutDirection.Left}
                        theme={IconButtonTheme.White}
                        size={IconButtonSize.Medium}
                        icon={faUserCircle}
                    >
                        <ul style={{ textAlign: 'left', display: 'grid', gap: '20px' }}>
                            <ProfileMenuOption
                                onClick={handleLogout}
                                icon={faSignOut}
                                menuSize={ProfileMenuSize.Regular}
                            >
                                Logout
                            </ProfileMenuOption>
                        </ul>
                    </IconFlyoutMenuButton>
                );
            } else {
                return (
                    <IconFlyoutMenuButton
                        id='menuButton'
                        direction={FlyoutDirection.Left}
                        theme={IconButtonTheme.Transparent}
                        size={IconButtonSize.Small}
                        icon={faBars}
                    >
                        <ul style={{ textAlign: 'left', display: 'grid', gap: '10px' }}>
                            {menuItems()}
                            <ProfileMenuOption
                                onClick={handleLogout}
                                icon={faSignOut}
                                menuSize={ProfileMenuSize.Condensed}
                            >
                                Logout
                            </ProfileMenuOption>
                        </ul>
                    </IconFlyoutMenuButton>
                );
            }
        }
    };

    return (
        <>
            {renderProfileButton(printMode)}
            <ConfirmV2
                id='confirmLogoutModal'
                open={isConfirmOpen}
                title='Confirm Logout'
                onConfirm={onConfirmLogout}
                onCancel={onCancelLogout}
                okLabel='Yes'
                cancelLabel='No'
                width='340px'
                height='200px'
            >
                Warning: Unsaved work may be lost
            </ConfirmV2>
        </>
    );
};
